module.exports = __webpack_public_path__ + "img/circle-v.8f7218e5.svg";